module.exports = __webpack_public_path__ + "img/Star.ee57f64c.svg";